export const parseVarieties = ({
  nombre,
  bancoSemillas,
}) => ({
  nombre,
  bancoDeSemillas: bancoSemillas,
});

export const parseVarietiesList = (list) => list?.map((camp) => parseVarieties(camp));
